import chatImg from '@/assets/images/chat_img.webp';
import './ChatButton.scss';
import { toast } from 'react-toastify';

interface ChatButtonProps {
    onClick: () => void;
    label?: string;
    style?: React.CSSProperties;
}

function ChatButton({ onClick, label = '채팅하기', style }: ChatButtonProps) {
    return <></>;
    return (
        <button
            className="chat-button"
            onClick={() => {
                onClick();
                // todo
                toast('곧 채팅 기능이 제공될 예정이에요👷‍♂️', {
                    position: 'top-center',
                    autoClose: 2000,
                    hideProgressBar: true,
                    pauseOnHover: false,
                    draggable: false,
                    style: {
                        borderRadius: '16px',
                        fontSize: '15px',
                        padding: '12px 20px',
                    },
                });
            }}
            aria-label={label}
            style={style}
        >
            <img src={chatImg} alt={label} />
        </button>
    );
}

export default ChatButton;
